import { useState, useEffect } from "react";
import { db, storage } from "../lib/firebase";
import { collection, query, where, onSnapshot } from "firebase/firestore";
import { ref, listAll, getDownloadURL } from "firebase/storage";

const DEFAULT_PROJECTS = [
    {
        id: "default-1",
        nombreProyecto: "Familia Marroquín",
        tipo: "Residencial",
        ubicacion: "Mixco, Guatemala",
        totalPaneles: 6,
        capacidadInstalada: 80,
        calificacion: 5,
        comentario: "Excelente ahorro desde el primer mes.",
        image: "https://placehold.co/800x600?text=Sin+Imagen",
        marcaPaneles: "Risen RSM132-8-660M",
        marcaInversor: "Huawei SUN2000-3KTL-L1",
        montaje: "Sistema de rieles Chiko en lámina",
        monitoreo: "Fusión Solar",
        carpeta: "FamiliaMarroquin"
    }
];

export const useProjects = () => {
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [maxPossibleGen, setMaxPossibleGen] = useState(20000);

    useEffect(() => {
        const q = query(
            collection(db, "proyectos"),
            where("visible", "==", true)
        );

        const unsubscribe = onSnapshot(
            q,
            async (snapshot) => {
                let rawProjects = [];
                if (snapshot.empty) {
                    rawProjects = DEFAULT_PROJECTS;
                } else {
                    rawProjects = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                }

                const projectList = [];
                let currentMax = 0;

                for (const data of rawProjects) {
                    // Formula: capInstalada (daily per panel) * totalPaneles
                    const generaDiaria = (parseFloat(data.capacidadInstalada / 30) || 0) * (parseInt(data.totalPaneles) || 0);
                    const generaMensual = data.capacidadInstalada * data.totalPaneles;
                    const generaAnual = generaMensual * 12;

                    if (generaMensual > currentMax) currentMax = generaMensual;

                    // Fetch the first image as cover image if carpeta exists
                    let coverImage = "";
                    if (data.carpeta) {
                        try {
                            const folderRef = ref(storage, `SolarValley/Proyectos/${data.carpeta}`);
                            const res = await listAll(folderRef);
                            if (res.items.length > 0) {
                                coverImage = await getDownloadURL(res.items[0]);
                            }
                        } catch (error) {
                            console.warn(`Error fetching cover image for ${data.nombreProyecto}:`, error);
                        }
                    }

                    projectList.push({
                        ...data,
                        generaDiaria,
                        generaMensual,
                        generaAnual,
                        image: coverImage || data.image || "https://placehold.co/800x600?text=Sin+Imagen",
                        order: data.orden ? Number(data.orden) : 999
                    });
                }

                // Sort by order 
                projectList.sort((a, b) => (a.order || 0) - (b.order || 0));

                // Update max generation scaling by hundreds
                const calculatedMax = Math.ceil(currentMax / 100) * 100 || 2000;
                setMaxPossibleGen(calculatedMax);
                setProjects(projectList);
                setLoading(false);
            },
            (error) => {
                console.error("Error fetching projects:", error);
                setProjects(DEFAULT_PROJECTS);
                setLoading(false);
            }
        );

        return () => unsubscribe();
    }, []);

    return { projects, loading, maxPossibleGen };
};
